import { createContext } from "react";

import { UserCompanyConfiguration } from "@/model/UserCompanyConfiguration/UserCompanyConfiguration";

export const UserCompanyConfigurationContext =
  createContext<UserCompanyConfiguration | null>(null);

export const UserCompanyConfigurationProvider =
  UserCompanyConfigurationContext.Provider;
export const UserCompanyConfigurationConsumer =
  UserCompanyConfigurationContext.Consumer;
